import React, { useState } from "react";
import { string, func, number, array, object, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./keyHighlights.m.css";

const goToCard = (cardId) => {
  if (cardId) {
    setTimeout(function () {
      document.getElementById(cardId) &&
        document.getElementById(cardId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
    }, 100);
  }
};

const KeyHighlights = ({ keyHighlights, lang, stickyHighlights }) => {
  const [indexValue, setIndexValue] = useState(null);
  const scrollEvent = (id, index) => {
    goToCard(id);
    if (index !== indexValue) {
      setIndexValue(index);
    }
  };

  return (
    <div styleName="wrapper" className={`key-highlights ${stickyHighlights ? "sticky-highlights" : ""}`}>
      <ul styleName="list" className="key-highlights-list">
        {keyHighlights.map((highlight, index) => {
          const cardName = index === 0 || index === keyHighlights.length - 1 ? "dash" : "circle";

          return (
            <KeyHighlight
              key={`highlight-${highlight.card.id}`}
              highlight={highlight}
              cardName={cardName}
              onClick={() => scrollEvent(highlight.card.id, index)}
              index={index}
              indexValue={indexValue}
              lang={lang}
            />
          );
        })}
      </ul>
    </div>
  );
};

const KeyHighlight = ({ highlight, cardName, onClick, index, indexValue, lang }) => (
  <li styleName="key" onClick={onClick}>
    <span styleName={`${cardName} ${index === indexValue ? "active" : ""}`} />
    <time styleName={`time`}>
      {new Date(highlight.card["card-added-at"]).toLocaleTimeString(lang === "en" ? "en" : "bn-BD", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
      })}
    </time>
    <div styleName="text">{highlight.title}</div>
  </li>
);

KeyHighlights.propTypes = {
  keyHighlights: array,
  stickyHighlights: bool,
  lang: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
});

KeyHighlight.propTypes = {
  highlight: object,
  cardName: string,
  onClick: func,
  index: number,
  indexValue: number,
  lang: string,
};

export default connect(mapStateToProps)(KeyHighlights);
